module.exports = function() {
  return new Worker(__webpack_public_path__ + "b2609589e7ffa70081df.worker.js");
};